// const imgBaseUrl = "http://120.78.210.233:8127/oss/uploadFile";
const imgBaseUrl = "https://api.mr-future.com/public/file/upload?folder=PC";

// const pdfUrl = "http://120.78.210.233:8127/";
const pdfUrl = "http://localhost:8127";
const pdfBaseUrl = "http://localhost:8127";

export default {
  imgBaseUrl,
  pdfBaseUrl,
};
